import { render, staticRenderFns } from "./OwnReports.vue?vue&type=template&id=77dc4b1b&scoped=true&"
import script from "./OwnReports.vue?vue&type=script&lang=js&"
export * from "./OwnReports.vue?vue&type=script&lang=js&"
import style0 from "./OwnReports.vue?vue&type=style&index=0&id=77dc4b1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc4b1b",
  null
  
)

export default component.exports